import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { LoadingScreen } from '../../components/LoadingScreen';

/**
 * Route guard that requires authentication
 * Redirects to sign in page if not authenticated
 */
export function AuthGuard() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingScreen message="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    // Save the attempted location to redirect back after login
    const currentPath = location.pathname + location.search;
    sessionStorage.setItem('oauth_redirect', currentPath);
    
    return <Navigate to="/signin?reason=unauthorized" replace />;
  }

  return <Outlet />;
}

